import React from 'react';
import { Switch, Route } from 'react-router-dom';
import DesignForm from '../../pages/design/detail/designForm.js';
import DesignEvent from '../../pages/design/event/designEvent.js';
import PageError from '../../pages/error/pageError';

export default function TicketsDesignEventRouter({ organization, event, path, menhirUrl }) {
    return (
        <Switch>
            <Route
                exact
                path={[`${path}/`, `${path}`]}
                render={({ match, history }) => {
                    return <DesignEvent organization={organization} event={event} activeTab={0} menhirUrl={menhirUrl} />;
                }}
            />
            <Route
                exact
                path={`${path}/new/`}
                render={({ match, history }) => {
                    return <DesignForm organization={organization} event={event} />;
                }}
            />
            <Route
                exact
                path={`${path}/:designId`}
                render={({ match, history }) => {
                    return <DesignForm organization={organization} event={event} designId={match.params.designId} />;
                }}
            />
            <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
        </Switch>
    );
}
